import { connect } from "react-redux";
import { Action, ThunkDispatch } from "@reduxjs/toolkit";

import { ApplicationState } from "../../redux/ApplicationState";
import { downloadDocumentOfNotification } from "../../actions/ReferralAction";
import PdfViewer from "../components/PdfViewer";

const mapStateToProps = ({
  downloadDocumentOfNotificationState,
}: ApplicationState) => ({
  downloadDocumentOfNotificationState: downloadDocumentOfNotificationState,
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<ApplicationState, Record<string, never>, Action<any>>
) => {
  return {
    downloadDocumentOfNotification: (blobId: number) => {
      dispatch(downloadDocumentOfNotification(blobId));
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(PdfViewer);